// extracted by mini-css-extract-plugin
module.exports = {"colorPanel":"couponEdit_colorPanel__15zpj","row":"couponEdit_row__1t2_x","customAttrs":"couponEdit_customAttrs__1BdId","ps":"couponEdit_ps__-oH0A","png":"couponEdit_png__286ny"};